import React, { useState } from "react";
import "./index.css"
import rev1 from "../../assets/rev1.svg"
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
export const Reviews = () => {
    const dynamicData = [
        { id: 1, title: 'Item 1' },
        { id: 2, title: 'Item 2' },
        { id: 3, title: 'Item 3' },
        { id: 4, title: 'Item 4' },
        { id: 5, title: 'Item 5' },
        { id: 6, title: 'Item 6' },
        { id: 7, title: 'Item 7' },
    ];

    const contentStyle = {
        margin: 0,
        height: '160px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
    };

    const chunkArray = (array, chunkSize) => {
        const result = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    };

    const onChange = (currentSlide) => {
        console.log('Slide changed to:', currentSlide);
    };

    const chunkedData = chunkArray(dynamicData, 2);
    return (
        <div className="container-art">
            <div className="container-art-1 my-3">
                <div className="d-flex justify-content-between align-item-center">
                    <div></div>
                    <div className="lead-sub">Reviews</div>
                    <div></div>
                </div>
                <br />
                <Carousel afterChange={onChange} showArrows={false} autoPlay={true} showIndicators={false} showStatus={false}>
                    {chunkedData.map((group, index) => (
                        <div key={index}>
                            <div className="row ">
                                {group.map((item) => (
                                    <div className="col-md-6 col-12 mb-3" key={item.id}>
                                        <div className="review-borders">
                                            <div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <div className="font-weight-bold">Jide Ogundiya</div>
                                                        <div className="primary">Lagos,Nigeria</div>
                                                    </div>
                                                    <div>
                                                        <img src={rev1} className="rev-img" />
                                                    </div>
                                                </div>

                                            </div>
                                            <br />
                                            <div>
                                                <i>
                                                    “The plumber I found was professional, skilled, and
                                                    reasonably priced. Fixed my kitchen sink issue in no time.
                                                    Highly recommend!”
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </Carousel>

                
            </div>
        </div>

    );
};

